import { render, staticRenderFns } from "./PublishSwitch.vue?vue&type=template&id=7b35e730&"
import script from "./PublishSwitch.vue?vue&type=script&lang=js&"
export * from "./PublishSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PublishSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCardText,VCol,VPagination,VRow,VSimpleTable,VSpacer,VTextField})
